import { ErrorMessage, Tooltip } from '@employ-engage/common-components';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export interface FindEmployeeFormProps {
  setFormOptions: (formOptions: any) => void;
  onSearchForForms: (
    employeeId: string,
    setErrors: (arg0: { employeeId: string }) => void
  ) => void;
  setIsFormsAvailable: (isFormsAvailable: boolean) => void;
}

export function FindEmployeeForm({
  setFormOptions,
  onSearchForForms,
  setIsFormsAvailable,
}: FindEmployeeFormProps) {
  const { t } = useTranslation(['common']);
  const { handleSubmit, handleChange, values, setFieldValue, errors, touched } =
    useFormik({
      initialValues: {
        employeeId: '',
      },
      onSubmit: (values, { setErrors }) => {
        onSearchForForms(values.employeeId, setErrors);
      },
      validationSchema: Yup.object({
        employeeId: Yup.string()
          .matches(/^[0-9]+$/, {
            message: t('Employee ID must be a number'),
          })
          .trim()
          .required(t('Required - Employee ID can be found on your badge')),
      }),
    });

  const handleEmployeeIdChange = (event: any) => {
    setFormOptions([]);
    setFieldValue('formId', '');
    setIsFormsAvailable(false);
    handleChange(event);
  };

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <div className="mb-10 flex flex-col justify-center items-center">
        <h2 className="text-center text-md sm:text-3xl font-bold mb-10">
          {t('Please enter your employee ID number')}
        </h2>
        <div className="flex flex-col">
          <div className="flex space-x-5">
            <input
              id="employeeId"
              name="employeeId"
              value={values.employeeId}
              onChange={handleEmployeeIdChange}
              autoFocus
              className="text-lg w-full max-w-[500px] sm:text-4xl text-custom-gray600 ring-2 ring-light-primary dark:ring-dark-primary border-2 border-light-primary dark:border-dark-primary bg-light-primaryBackground dark:bg-dark-primary rounded-lg p-2"
              type="text"
            />
            <Tooltip label="Search for Employee ID">
              <button type="submit">
                <i className="fa-solid fa-magnifying-glass text-3xl" />
              </button>
            </Tooltip>
          </div>
          <ErrorMessage
            errors={errors.employeeId}
            touched={touched.employeeId}
          />
        </div>
      </div>
    </form>
  );
}

export default FindEmployeeForm;
